// extracted by mini-css-extract-plugin
module.exports = {"flagLink":"FlagLink-module--flagLink--2SnTA","flagLinkColumn":"FlagLink-module--flagLinkColumn--2XQ8q","flagWrapper":"FlagLink-module--flagWrapper--1qJQe"};